import { useCallContext } from "./Call/CallContext";

export const LatencyDisplay = () => {
  const { transcript } = useCallContext();
  const latestEndLatency =
    transcript.length > 0
      ? transcript[transcript.length - 1].end_latency?.toFixed(2)
      : null;

  const averageEndLatency =
    transcript.reduce((sum, item) => sum + (item.end_latency ?? 0), 0) /
    transcript.length;

  const formattedAverageEndLatency = averageEndLatency
    ? Math.floor(averageEndLatency)
    : "N/A";

  return (
    <div className="flex w-full flex-col space-y-2 border-b border-gray-300 bg-gray-50 p-2 px-3 text-xs text-gray-500">
      <div className="flex flex-row space-x-4">
        <div>Latency:</div>
        <div>{latestEndLatency}ms</div>
        <div>{formattedAverageEndLatency}ms (Average)</div>
      </div>
    </div>
  );
};
